var _path, _path2, _circle, _circle2, _path3, _rect, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 43.8853L5 61.4289",
    stroke: "#703BDA",
    strokeWidth: 3.46363,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3633 43.8854L78.3633 61.429",
    stroke: "#703BDA",
    strokeWidth: 3.46363,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9651,
    cy: 52.2664,
    r: 3.37176,
    stroke: "#703BDA",
    strokeWidth: 3.46363
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.3987,
    cy: 52.2664,
    r: 3.37176,
    stroke: "#703BDA",
    strokeWidth: 3.46363
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0437 29.7572H69.3163V26.2936H14.0437V29.7572ZM71.0481 31.489V73.8057H74.5117V31.489H71.0481ZM69.3163 75.5376H14.0437V79.0012H69.3163V75.5376ZM12.3119 73.8057V31.489H8.84826V73.8057H12.3119ZM14.0437 75.5376C13.0873 75.5376 12.3119 74.7622 12.3119 73.8057H8.84826C8.84826 76.6751 11.1743 79.0012 14.0437 79.0012V75.5376ZM71.0481 73.8057C71.0481 74.7622 70.2727 75.5376 69.3163 75.5376V79.0012C72.1856 79.0012 74.5117 76.6751 74.5117 73.8057H71.0481ZM69.3163 29.7572C70.2727 29.7572 71.0481 30.5326 71.0481 31.489H74.5117C74.5117 28.6197 72.1856 26.2936 69.3163 26.2936V29.7572ZM14.0437 26.2936C11.1743 26.2936 8.84826 28.6197 8.84826 31.489H12.3119C12.3119 30.5326 13.0873 29.7572 14.0437 29.7572V26.2936Z",
    fill: "#703BDA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.8849,
    y: 14.3792,
    width: 1.59487,
    height: 12.7589,
    fill: "#703BDA",
    stroke: "#703BDA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.6825,
    cy: 11.9872,
    r: 2.7749,
    stroke: "#703BDA",
    strokeWidth: 2.42454
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.3d8d0809dbe188be58ec7eb16d63e38c.svg";
export { ForwardRef as ReactComponent };